(() => {
  'use strict';

  const ERROR_MESSAGE_TIMEOUT = 5000;
  const ERROR_MESSAGE = "'Make Your Own Gift Box' cannot be purchased with a subscription product. Please remove one of these items to proceed.";
  const ERROR_MESSAGE_RESTRICTED = "Chocolatey Cold-Pack products must be ordered separately. If you have other products in your cart, please create a separate order.";

  // Cached DOM references and initialization flags
  const cache = {
    initialized: false,
    // main cart
    gsToggleStyle: null,
    multishipMsgMain: null,
    multishipMsgMainBundle: null,
    restrictedMsgMain: null,
    checkoutBtn: null,
    checkoutTooltip: null,
    checkoutStatus: null,
    checkoutError: null,
    cartForm: null,
    // drawer
    multishipAnchors: null,
    multishipMsgDrawer: null,
    multishipMsgDrawerBundle: null,
    restrictedMsgDrawer: null,
    drawerScrollables: null,
    viewCartBtn: null,
  };

  function initCache() {
    if (cache.initialized) return;
    cache.gsToggleStyle = document.getElementById('gs-toggle-box'); // style element used on main cart
    cache.multishipMsgMain = document.getElementById('multiship-message-main-cart');
    cache.multishipMsgMainBundle = document.getElementById('multiship-message-main-cart-bundle');
    cache.restrictedMsgMain = document.getElementById('restricted-sku-message-main-cart');

    cache.checkoutBtn = document.getElementById('checkout');
    cache.checkoutTooltip = document.getElementById('checkout-tooltip-message');
    cache.checkoutStatus = document.getElementById('checkout-status-message');
    cache.checkoutError = document.getElementById('checkout-error-message');
    cache.cartForm = document.getElementById('CartPageForm');

    // drawer equivalents
    cache.multishipAnchors = Array.from(document.querySelectorAll('a[href="/a/gs/cart/"]'));
    cache.multishipMsgDrawer = document.getElementById('multiship-message-cart-drawer');
    cache.multishipMsgDrawerBundle = document.getElementById('multiship-message-cart-drawer-bundle');
    cache.restrictedMsgDrawer = document.getElementById('restricted-sku-message-cart-drawer');
    cache.drawerScrollables = Array.from(document.querySelectorAll('.drawer__scrollable'));
    cache.viewCartBtn = document.querySelector('.drawer__footer a.btn.cart__checkout[href="/cart"]');

    cache.initialized = true;


  }

  // Fetch cart JSON (view=data expected to return JSON with items)
  function fetchCartData() {
    return fetch(window.Shopify.routes.root + 'cart?view=data', { credentials: 'same-origin' })
      .then(resp => {
        
        if (!resp.ok) throw new Error('Failed to fetch cart');
        return resp.json();
      });
  }

  // Analyze cart payload and return flags
  function analyzeCart(cartData) {
    const result = {
      hideMultiship: false,
      isBundle: false,
      hasSubscription: false,
      hasBundleSKU: false,
      hasRestrictedSKU: false,
      hasRegularProduct: false,
      hasMixedCart: false
    };

    if (!cartData || !Array.isArray(cartData.items)) return result;

    let restrictedCount = 0;
    let regularCount = 0;

    for (let i = 0; i < cartData.items.length; i++) {
      const item = cartData.items[i];
      const tags = Array.isArray(item.product_tags) ? item.product_tags : (typeof item.product_tags === 'string' ? item.product_tags.split(',').map(t => t.trim()) : []);

      if (item.selling_plan_allocation) {
        result.hideMultiship = true;
        result.hasSubscription = true;
      }

      if (tags.includes('easy-bundle')) {
        result.hideMultiship = true;
        result.isBundle = true;

        if (tags.includes('smart-cart-hide-bundle-options')){
          result.hasBundleSKU = true;
        }
      }

      // Check for restricted SKU tag
      if (tags.includes('restricted-separate-order')) {
        result.hasRestrictedSKU = true;
        restrictedCount++;
      } else {
        result.hasRegularProduct = true;
        regularCount++;
      }
    }

    // Determine if cart has mixed products
    if (restrictedCount > 0 && regularCount > 0) {
      result.hasMixedCart = true;
    }

    return result;
  }

  // Update UI across main cart and drawer
  function updateUI(flags) {
    initCache();

    // ===== multiship: drawer anchors (link) =====
    const shouldHideMultiship = flags.hideMultiship || flags.hasMixedCart;
    if (cache.multishipAnchors && cache.multishipAnchors.length) {
      cache.multishipAnchors.forEach(a => {
        a.style.display = shouldHideMultiship ? 'none' : 'inline-block';
      });
    }

    // ===== multiship: main cart uses a style element to toggle the button =====
    if (cache.gsToggleStyle) {
      cache.gsToggleStyle.innerHTML = shouldHideMultiship ? "#gs__toggle-box{display:none;}" : "#gs__toggle-box{display:inline-block;}";
    }

    // ===== VIEW CART button: hide ONLY when mixed cart (not for bundles/subscriptions alone) =====
    if (cache.viewCartBtn) {
      cache.viewCartBtn.style.display = flags.hasMixedCart ? 'none' : '';
    }

    // ===== messages: show/hide based on bundle/subscription =====
    if (cache.multishipMsgDrawer) {
      cache.multishipMsgDrawer.style.display = (flags.hideMultiship && !flags.isBundle) ? 'inline-block' : 'none';
    }
    if (cache.multishipMsgDrawerBundle) {
      cache.multishipMsgDrawerBundle.style.display = (flags.hideMultiship && flags.isBundle) ? 'inline-block' : 'none';
    }
    if (cache.multishipMsgMain) {
      cache.multishipMsgMain.classList.toggle('cart-message--hidden', !(flags.hideMultiship && !flags.isBundle));
    }
    if (cache.multishipMsgMainBundle) {
      cache.multishipMsgMainBundle.classList.toggle('cart-message--hidden', !(flags.hideMultiship && flags.isBundle));
    }

    // ===== messages: show/hide restricted SKU message =====
    if (cache.restrictedMsgDrawer) {
      cache.restrictedMsgDrawer.style.display = flags.hasMixedCart ? 'inline-block' : 'none';
    }
    if (cache.restrictedMsgMain) {
      cache.restrictedMsgMain.classList.toggle('cart-message--hidden', !flags.hasMixedCart);
    }

    // drawer scroll area resize tweak (keeps previous behavior)
    if (cache.drawerScrollables && cache.drawerScrollables.length) {
      cache.drawerScrollables.forEach(d => {
        d.style.height = flags.hideMultiship ? '1px' : 'unset';
      });
    }

    // ===== main cart checkout enabling/disabling =====
    if (cache.checkoutBtn) {
      const shouldBlockCheckout = (flags.hasSubscription && flags.hasBundleSKU) || flags.hasMixedCart;

      if (shouldBlockCheckout) {
        cache.checkoutBtn.setAttribute('disabled', 'disabled');
        cache.checkoutBtn.setAttribute('aria-disabled', 'true');
        cache.checkoutBtn.setAttribute('data-checkout-blocked', 'true');
        cache.checkoutBtn.setAttribute('data-block-reason', flags.hasMixedCart ? 'restricted' : 'bundle-subscription');
        cache.checkoutBtn.classList.add('checkout-btn--disabled');
        if (cache.checkoutStatus) cache.checkoutStatus.textContent = 'Checkout is currently disabled';
        if (cache.checkoutTooltip) cache.checkoutTooltip.setAttribute('aria-hidden', 'false');
      } else {
        cache.checkoutBtn.removeAttribute('disabled');
        cache.checkoutBtn.removeAttribute('aria-disabled');
        cache.checkoutBtn.removeAttribute('data-checkout-blocked');
        cache.checkoutBtn.removeAttribute('data-block-reason');
        cache.checkoutBtn.classList.remove('checkout-btn--disabled');
        if (cache.checkoutStatus) cache.checkoutStatus.textContent = 'Checkout is now available';
        if (cache.checkoutTooltip) {
          cache.checkoutTooltip.classList.remove('checkout-tooltip--visible');
          cache.checkoutTooltip.setAttribute('aria-hidden', 'true');
        }
      }
    }
  }

  // Public flow: fetch -> analyze -> update
  function checkSubscription() {
    return fetchCartData()
      .then(data => {
        const flags = analyzeCart(data);
        updateUI(flags);
        return flags;
      })
      .catch(err => {
        // keep console logging for debugging in theme
        console.error('cart-extensions: Error fetching/analyzing cart', err);
      });
  }

  // Attach checkout tooltip & blocked behaviour (main cart)
  function attachCheckoutHandlers() {
    initCache();

    // Guard: avoid attaching multiple times
    if (!attachCheckoutHandlers._attached && cache.checkoutBtn) {
      const tooltip = cache.checkoutTooltip;
      const errorDiv = cache.checkoutError;

      const showTooltip = function () {
        if (cache.checkoutBtn.hasAttribute('data-checkout-blocked') && tooltip) {
          tooltip.classList.add('checkout-tooltip--visible');
          tooltip.setAttribute('aria-hidden', 'false');
        }
      };
      const hideTooltip = function () {
        if (tooltip) {
          tooltip.classList.remove('checkout-tooltip--visible');
          tooltip.setAttribute('aria-hidden', 'true');
        }
      };

      cache.checkoutBtn.addEventListener('mouseenter', showTooltip);
      cache.checkoutBtn.addEventListener('mouseleave', hideTooltip);
      cache.checkoutBtn.addEventListener('focus', showTooltip);
      cache.checkoutBtn.addEventListener('blur', hideTooltip);

      // Intercept click to show accessible error if blocked
      cache.checkoutBtn.addEventListener('click', function (ev) {
        if (this.hasAttribute('data-checkout-blocked')) {
          ev.preventDefault();
          ev.stopPropagation();
          if (errorDiv) {
            const blockReason = this.getAttribute('data-block-reason');
            errorDiv.textContent = blockReason === 'restricted' ? ERROR_MESSAGE_RESTRICTED : ERROR_MESSAGE;
            errorDiv.classList.add('checkout-error--visible');
            // scroll into view if possible
            try { errorDiv.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (e) {}
            setTimeout(() => errorDiv.classList.remove('checkout-error--visible'), ERROR_MESSAGE_TIMEOUT);
          }
          return false;
        }
      });

      // Validate form submission in case user tries to submit a cart form
      if (cache.cartForm) {
        cache.cartForm.addEventListener('submit', function (ev) {
          if (cache.checkoutBtn && cache.checkoutBtn.hasAttribute('data-checkout-blocked')) {
            ev.preventDefault();
            ev.stopPropagation();
            if (errorDiv) {
              const blockReason = cache.checkoutBtn.getAttribute('data-block-reason');
              errorDiv.textContent = blockReason === 'restricted' ? ERROR_MESSAGE_RESTRICTED : ERROR_MESSAGE;
              errorDiv.classList.add('checkout-error--visible');
              try { errorDiv.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (e) {}
              setTimeout(() => errorDiv.classList.remove('checkout-error--visible'), ERROR_MESSAGE_TIMEOUT);
            }
            return false;
          }
        });
      }

      attachCheckoutHandlers._attached = true;
    }
  }

        function attachAddToCartHandler() {
        document.addEventListener('submit', function (ev) {
            const form = ev.target;
            if (!form || !form.matches) return;

            // Detect add-to-cart forms
            if (form.matches('form[action="/cart/add"]')) {
            // DO NOT prevent submission — let theme.js handle everything

            // After theme finishes updating the cart (AJAX),
            // wait a bit then re-run subscription logic
            setTimeout(() => {
                checkSubscription();
                // fire a lightweight "cart:updated" event for consistency
                document.dispatchEvent(new CustomEvent('cart:updated'));
            }, 300); // 300ms is usually enough for Shopify add.js response
            }
        }, true);
        }

  // Listen for custom 'cart:updated' events to re-run logic
  function attachCartUpdatedListener() {
    document.addEventListener('cart:updated', (ev) => {

      // some dispatchers pass detail as cart object
      // run checkSubscription regardless
      checkSubscription();
    });

    // Listen for Shopify AJAX cart events
    document.addEventListener('ajaxCart:added', () => {
      setTimeout(() => checkSubscription(), 300);
    });

    // Listen for theme-specific cart update events
    document.addEventListener('theme:cart:change', () => {
      setTimeout(() => checkSubscription(), 300);
    });

    // Listen for any button clicks that might add to cart
    document.addEventListener('click', (e) => {
      const button = e.target.closest('button, a');
      if (button && (
        button.textContent.includes('Add to Cart') ||
        button.textContent.includes('ADD TO CART') ||
        button.classList.contains('add-to-cart') ||
        button.getAttribute('data-action') === 'add-to-cart'
      )) {
        // Wait for AJAX to complete
        setTimeout(() => checkSubscription(), 500);
      }
    }, true);
  }

  // Watch for drawer opening
  function watchDrawer() {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    // Use MutationObserver to detect when drawer opens
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' &&
            (mutation.attributeName === 'class' || mutation.attributeName === 'style')) {
          // Drawer might have opened, check cart
          setTimeout(() => checkSubscription(), 200);
        }
      });
    });

    observer.observe(drawer, {
      attributes: true,
      attributeFilter: ['class', 'style']
    });

    // Also watch for any child changes in the drawer (cart items updated)
    const drawerContent = drawer.querySelector('[data-products]');
    if (drawerContent) {
      const contentObserver = new MutationObserver(() => {
        setTimeout(() => checkSubscription(), 200);
      });
      contentObserver.observe(drawerContent, {
        childList: true,
        subtree: true
      });
    }
  }

  // Periodic check for cart changes (useful for cart page)
  function startPeriodicCheck() {
    // Only run periodic checks on cart page
    if (window.location.pathname === '/cart' || document.querySelector('[data-location="cart-drawer"]')) {
      setInterval(() => {
        checkSubscription();
      }, 2000); // Check every 2 seconds
    }
  }

  // Bootstrapping: run initial check and attach handlers when DOM ready
  function bootstrap() {
    initCache();
    checkSubscription();
    attachCheckoutHandlers();
    attachAddToCartHandler();
    attachCartUpdatedListener();
    watchDrawer();
    startPeriodicCheck();

    // Also check when page becomes visible (user switches tabs)
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        checkSubscription();
      }
    });
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    // DOM is ready-ish
    bootstrap();
  } else {
    document.addEventListener('DOMContentLoaded', bootstrap);
  }

  // Expose a small debug API (optional)
  window.CartExtensions = {
    checkSubscription,
    analyzeCart,
    updateUI
  };
})();
